export default "__VITE_ASSET__Cts6qIP2__"